import { gql, TypedDocumentNode } from '@apollo/client';

export const OnStateUpdateOperationName = 'OnStateUpdated';

export const onStateUpdateQuery: TypedDocumentNode<
  { statesUpdated: string },
  { fileId: string }
> = gql`
  subscription OnStateUpdated($fileId: UUID!) {
    statesUpdated(fileId: $fileId) {
      updatedAt
    }
  }
`;
